import React from 'react';

/**
 * 通用數據表格組件
 * @param {Object} props
 * @param {Array} props.columns - 表格列配置
 * @param {Array} props.data - 表格數據
 * @param {string} props.emptyMessage - 當沒有數據時顯示的訊息
 * @param {boolean} props.isLoading - 是否正在加載數據
 * @param {function} props.onRowClick - 行點擊事件回調
 */
const DataTable = ({
    columns,
    data,
    emptyMessage = "沒有數據",
    isLoading = false,
    onRowClick = null,
}) => {
    if (isLoading) {
        return (
            <div className="py-12 flex justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="py-12 text-center text-gray-500">
                {emptyMessage}
            </div>
        );
    }

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full">
                <thead>
                    <tr className="bg-gray-50">
                        {columns.map((column, index) => (
                            <th
                                key={index}
                                className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                style={column.width ? { width: column.width } : {}}
                            >
                                {column.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                    {data.map((row, rowIndex) => (
                        <tr
                            key={rowIndex}
                            className={`bg-white ${onRowClick ? 'cursor-pointer hover:bg-gray-50' : ''}`}
                            onClick={onRowClick ? () => onRowClick(row) : undefined}
                        >
                            {columns.map((column, colIndex) => (
                                <td key={colIndex} className="px-4 py-3 text-sm">
                                    {column.cell ? column.cell(row) : row[column.accessor]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;